import axios from '../axios'
// ip登录
export const login = data => {
    return axios({
        url: '/iplogin',
        method: 'get',
        params: data
    })
}
//账号登录
export const orglogin = data => {
    return axios({
        url: '/login',
        method: 'post',
        data: data
    })
}
//个人登录
export const userlogin = data => { 
    return axios({
        url: '/login_user',
        method: 'post',
        data: data
    })
}

